import React from "react";

const PaymentForm = ({ amount, onSubmit, isProcessing }) => {
  return (
    <div className="bg-dark-card rounded-xl p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-medium text-white">Payment Details</h2>
        {/* Add Billplz logo */}
        <img src="/billplz-logo.png" alt="Billplz" className="h-8" />
      </div>

      <div className="space-y-4">
        <div className="bg-dark-bg p-4 rounded-lg">
          <p className="text-gray-400">Amount to pay:</p>
          <p className="text-2xl font-bold text-white">MYR {amount}</p>
        </div>

        <button
          onClick={onSubmit}
          disabled={isProcessing}
          className="w-full bg-blue-500 text-white py-3 rounded-lg hover:bg-blue-600 transition-colors disabled:opacity-50"
        >
          {isProcessing ? "Processing..." : "Pay Now"}
        </button>
      </div>
    </div>
  );
};

export default PaymentForm;
